/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
import { type SVGProps } from 'react'
import { cn } from '@/lib/utils'

/**
 * Official PayPal PP monogram (single-shape) painted in PayPal brand blue (#003087).
 * Path data is the verified Simple Icons SiPaypal glyph (CC0 / public).
 * Renders at a fixed brand color; pass `className` for sizing.
 */
export function IconPaypal({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      role='img'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      className={cn(className)}
      fill='#003087'
      {...props}
    >
      <title>PayPal</title>
      <path d='M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81 1.01 1.15 1.304 2.42 1.012 4.287-.023.143-.047.288-.077.437-.983 5.05-4.349 6.797-8.647 6.797h-2.19c-.524 0-.968.382-1.05.9l-1.12 7.106zm14.146-14.42a3.35 3.35 0 0 0-.607-.541c-.013.076-.026.175-.041.254-.59 3.025-2.566 4.967-5.282 5.957a8.93 8.93 0 0 1-3.026.428H7.076c-.524 0-.968.382-1.05.9L4.97 21.022a.641.641 0 0 0 .633.74h4.606l.073-.465.866-5.475.056-.305c.082-.518.526-.9 1.05-.9h.66c4.27 0 7.617-1.737 8.597-6.76.41-2.103.198-3.86-.86-5.092z' />
    </svg>
  )
}
